export interface Video {
  id: string;
  title: string;
  description: string;
  cover: string;
  categoryId: string;
  subCategory: string;
  tags: string[];
  duration: number;
  uploadDate: string;
  views: number;
  uploader: string;
  featured: boolean;
}

export const videos: Video[] = [
  {
    id: 'v1',
    title: '明星红毯幕后全记录：镜头外的高光瞬间',
    description:
      '带你走进颁奖礼红毯的台前幕后，从造型团队准备到闪光灯下的定格，完整还原一场顶级娱乐盛典的每一个高光瞬间。',
    cover:
      'https://readdy.ai/api/search-image?query=Glamorous%20celebrity%20red%20carpet%20event%20with%20bright%20spotlights%20and%20elegant%20stage%2C%20cinematic%20atmosphere%2C%20warm%20golden%20lighting%20against%20deep%20navy%20background%2C%20high%20detail%20editorial%20photography%2C%20premium%20magazine%20look&width=1280&height=720&seq=vs-v1&orientation=landscape',
    categoryId: 'entertainment',
    subCategory: '红毯现场',
    tags: ['明星', '红毯', '颁奖礼'],
    duration: 742,
    uploadDate: '2026-10-09',
    views: 1284000,
    uploader: '星光观察员',
    featured: true,
  },
  {
    id: 'v2',
    title: '爆款剧集高能名场面合集：一口气看到爽',
    description:
      '精选本季度讨论度最高的剧集名场面，反转、高燃、催泪一次看全，附带镜头解析，帮你重温那些让人上头的瞬间。',
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20dramatic%20television%20scene%20with%20moody%20lighting%20and%20tense%20atmosphere%2C%20warm%20amber%20highlights%20on%20dark%20blue%20backdrop%2C%20film%20still%20style%20editorial%20photography%2C%20rich%20contrast%20and%20detail&width=1280&height=720&seq=vs-v2&orientation=landscape',
    categoryId: 'entertainment',
    subCategory: '剧集花絮',
    tags: ['剧集', '名场面', '合集'],
    duration: 968,
    uploadDate: '2026-10-07',
    views: 962300,
    uploader: '追剧小分队',
    featured: true,
  },
  {
    id: 'v3',
    title: '音乐节万人现场直击：把夏天唱到最后一秒',
    description:
      '从午后到深夜，记录一场万人音乐节的完整现场。荧光海、大合唱与烟花谢幕，隔着屏幕都能感受到的热浪。',
    cover:
      'https://readdy.ai/api/search-image?query=Huge%20outdoor%20music%20festival%20crowd%20with%20stage%20lights%20and%20glowing%20phone%20lights%20at%20night%2C%20energetic%20warm%20orange%20atmosphere%2C%20cinematic%20wide%20shot%2C%20deep%20navy%20night%20sky%2C%20high%20detail%20editorial%20photography&width=1280&height=720&seq=vs-v3&orientation=landscape',
    categoryId: 'entertainment',
    subCategory: '现场演出',
    tags: ['音乐节', '现场', '夏天'],
    duration: 512,
    uploadDate: '2026-10-05',
    views: 743100,
    uploader: '现场收音台',
    featured: false,
  },
  {
    id: 'v4',
    title: '电影级短片幕后制作揭秘：一支镜头的诞生',
    description:
      '跟拍一支电影级短片的完整制作过程，从分镜、布光到调色，揭秘那些令人惊叹的画面究竟是怎样被拍出来的。',
    cover:
      'https://readdy.ai/api/search-image?query=Film%20production%20behind%20the%20scenes%20with%20camera%20rig%20and%20lighting%20crew%20on%20set%2C%20warm%20cinematic%20studio%20lighting%2C%20dark%20blue%20industrial%20backdrop%2C%20editorial%20documentary%20photography%2C%20high%20detail&width=1280&height=720&seq=vs-v4&orientation=landscape',
    categoryId: 'entertainment',
    subCategory: '幕后花絮',
    tags: ['幕后', '电影', '短片'],
    duration: 634,
    uploadDate: '2026-10-02',
    views: 388200,
    uploader: '镜后笔记',
    featured: false,
  },
  {
    id: 'v5',
    title: '一个人的周末咖啡馆时光：慢下来刚刚好',
    description:
      '记录一个人度过周末的小小仪式感：一杯手冲、一本旧书和窗外的阳光，给忙碌的生活按下暂停键。',
    cover:
      'https://readdy.ai/api/search-image?query=Cozy%20quiet%20coffee%20shop%20interior%20with%20warm%20afternoon%20sunlight%2C%20wooden%20table%20and%20pour%20over%20coffee%2C%20soft%20warm%20beige%20tones%20with%20deep%20blue%20shadows%2C%20lifestyle%20editorial%20photography%2C%20high%20detail&width=1280&height=720&seq=vs-v5&orientation=landscape',
    categoryId: 'life',
    subCategory: '美食日常',
    tags: ['咖啡', '周末', '慢生活'],
    duration: 421,
    uploadDate: '2026-10-10',
    views: 521000,
    uploader: '慢时光手记',
    featured: true,
  },
  {
    id: 'v6',
    title: '十分钟搞定一人食晚餐：好吃到舔盘',
    description:
      '一个人也要好好吃饭。教你用十分钟做出一道简单又有仪式感的家常晚餐，食材常见、步骤清晰，新手也能一次成功。',
    cover:
      'https://readdy.ai/api/search-image?query=Home%20cooked%20simple%20dinner%20on%20a%20small%20wooden%20table%20with%20steam%20and%20warm%20lighting%2C%20fresh%20ingredients%20in%20soft%20focus%2C%20cozy%20warm%20tones%20against%20dark%20background%2C%20food%20editorial%20photography%2C%20appetizing%20detail&width=1280&height=720&seq=vs-v6&orientation=landscape',
    categoryId: 'life',
    subCategory: '美食日常',
    tags: ['一人食', '料理', '教程'],
    duration: 318,
    uploadDate: '2026-10-08',
    views: 476900,
    uploader: '厨房小白日记',
    featured: false,
  },
  {
    id: 'v7',
    title: '出租屋改造前后对比：预算内住出高级感',
    description:
      '用有限预算把出租屋改造成理想中的样子。完整的改造流程、软装清单与避坑经验，看完就想立刻动手。',
    cover:
      'https://readdy.ai/api/search-image?query=Small%20apartment%20interior%20makeover%20with%20minimal%20warm%20furniture%20and%20soft%20indoor%20lighting%2C%20cozy%20neutral%20beige%20palette%20with%20deep%20blue%20accents%2C%20home%20decor%20editorial%20photography%2C%20high%20detail&width=1280&height=720&seq=vs-v7&orientation=landscape',
    categoryId: 'life',
    subCategory: '家居改造',
    tags: ['出租屋', '家居', '改造'],
    duration: 587,
    uploadDate: '2026-10-04',
    views: 612400,
    uploader: '住进理想家',
    featured: false,
  },
  {
    id: 'v8',
    title: '城市骑行一日记录：把街景装进车轮里',
    description:
      '沿着城市的老街与河岸骑行一整天，用镜头记录沿途的烟火气、光影与人情味，这是一份写给城市的情书。',
    cover:
      'https://readdy.ai/api/search-image?query=City%20cycling%20route%20along%20a%20riverside%20at%20golden%20hour%20with%20warm%20sunlight%20and%20urban%20skyline%2C%20cinematic%20motion%20feel%2C%20deep%20navy%20shadows%2C%20travel%20editorial%20photography%2C%20high%20detail&width=1280&height=720&seq=vs-v8&orientation=landscape',
    categoryId: 'life',
    subCategory: '旅行记录',
    tags: ['骑行', '城市', 'vlog'],
    duration: 655,
    uploadDate: '2026-09-30',
    views: 297600,
    uploader: '慢骑计划',
    featured: false,
  },
  {
    id: 'v9',
    title: '猫咪迷惑行为大赏：铲屎官笑到扶墙',
    description:
      '收集全网最离谱的猫咪迷惑行为，从半夜跑酷到空气啃咬，每一只都精准踩中铲屎官的笑点。',
    cover:
      'https://readdy.ai/api/search-image?query=Playful%20funny%20cat%20in%20a%20cozy%20living%20room%20with%20warm%20lighting%2C%20expressive%20cute%20pose%20and%20soft%20focus%20background%2C%20warm%20orange%20tones%20against%20deep%20blue%20shadows%2C%20pet%20editorial%20photography%2C%20high%20detail&width=1280&height=720&seq=vs-v9&orientation=landscape',
    categoryId: 'funny',
    subCategory: '萌宠搞笑',
    tags: ['猫咪', '萌宠', '搞笑'],
    duration: 356,
    uploadDate: '2026-10-11',
    views: 1523000,
    uploader: '铲屎官联盟',
    featured: true,
  },
  {
    id: 'v10',
    title: '办公室爆笑迷惑瞬间：打工人的快乐源泉',
    description:
      '真实还原办公室里那些让人笑出声的名场面，从开会走神到茶水间偶遇，献给每一个努力生活的打工人。',
    cover:
      'https://readdy.ai/api/search-image?query=Funny%20office%20scene%20with%20modern%20coworking%20space%20and%20warm%20indoor%20lighting%2C%20playful%20energetic%20atmosphere%2C%20warm%20amber%20accents%20on%20dark%20blue%20interior%2C%20editorial%20photography%2C%20high%20detail&width=1280&height=720&seq=vs-v10&orientation=landscape',
    categoryId: 'funny',
    subCategory: '生活搞笑',
    tags: ['办公室', '打工人', '搞笑'],
    duration: 289,
    uploadDate: '2026-10-09',
    views: 987200,
    uploader: '摸鱼研究所',
    featured: false,
  },
  {
    id: 'v11',
    title: '街头整蛊路人反应合集：笑点密集预警',
    description:
      '精心设计的街头小整蛊，看路人从惊讶到爆笑的全过程反应，全程高能，笑点密集请谨慎观看。',
    cover:
      'https://readdy.ai/api/search-image?query=Playful%20street%20scene%20with%20people%20reacting%20and%20laughing%20in%20a%20city%20square%20at%20dusk%2C%20warm%20street%20lighting%2C%20energetic%20candid%20atmosphere%2C%20deep%20navy%20evening%20tones%2C%20editorial%20photography&width=1280&height=720&seq=vs-v11&orientation=landscape',
    categoryId: 'funny',
    subCategory: '街头整蛊',
    tags: ['整蛊', '路人', '反应'],
    duration: 412,
    uploadDate: '2026-10-06',
    views: 834500,
    uploader: '快乐制造局',
    featured: false,
  },
  {
    id: 'v12',
    title: '沙雕动画脑洞合集：逻辑鬼才上线',
    description:
      '脑洞大开的沙雕动画合集，荒诞的设定配合一本正经的演出，专治各种不开心，看完直呼离谱。',
    cover:
      'https://readdy.ai/api/search-image?query=Colorful%20playful%20cartoon%20animation%20scene%20with%20vivid%20expressive%20characters%20and%20warm%20bright%20palette%2C%20fun%20dynamic%20composition%20with%20deep%20blue%20accents%2C%20stylized%20illustration%2C%20high%20detail&width=1280&height=720&seq=vs-v12&orientation=landscape',
    categoryId: 'funny',
    subCategory: '沙雕动画',
    tags: ['动画', '脑洞', '沙雕'],
    duration: 378,
    uploadDate: '2026-10-03',
    views: 623800,
    uploader: '脑洞放映厅',
    featured: false,
  },
  {
    id: 'v13',
    title: '街头艺人翻唱经典老歌：一开口就是回忆',
    description:
      '城市的某个转角，一把吉他一段熟悉的旋律。街头艺人用最朴素的方式翻唱经典老歌，唱哭了路过的每个人。',
    cover:
      'https://readdy.ai/api/search-image?query=Street%20musician%20playing%20acoustic%20guitar%20at%20a%20city%20corner%20in%20warm%20evening%20light%2C%20intimate%20emotional%20atmosphere%2C%20golden%20highlights%20against%20deep%20blue%20dusk%2C%20editorial%20photography%2C%20high%20detail&width=1280&height=720&seq=vs-v13&orientation=landscape',
    categoryId: 'music',
    subCategory: '街头翻唱',
    tags: ['翻唱', '老歌', '街头'],
    duration: 296,
    uploadDate: '2026-10-10',
    views: 715400,
    uploader: '城市收音机',
    featured: true,
  },
  {
    id: 'v14',
    title: '深夜民谣现场版：适合一个人的夜晚',
    description:
      '昏黄灯光下的一场小型民谣现场，简单的和弦与温柔的人声，献给所有在深夜仍未睡着的你。',
    cover:
      'https://readdy.ai/api/search-image?query=Intimate%20acoustic%20folk%20music%20session%20in%20a%20dim%20warm%20lit%20room%2C%20single%20guitar%20and%20microphone%2C%20cozy%20amber%20glow%20against%20deep%20blue%20shadows%2C%20moody%20editorial%20photography%2C%20high%20detail&width=1280&height=720&seq=vs-v14&orientation=landscape',
    categoryId: 'music',
    subCategory: '民谣现场',
    tags: ['民谣', '现场', '深夜'],
    duration: 823,
    uploadDate: '2026-10-01',
    views: 342700,
    uploader: '晚风唱片',
    featured: false,
  },
  {
    id: 'v15',
    title: '电音派对高能现场：把心跳交给鼓点',
    description:
      '一场燃到极致的电音派对实录，炫目的灯光、涌动的音浪与沉浸的人群，带你重温那个沸腾的夜晚。',
    cover:
      'https://readdy.ai/api/search-image?query=High%20energy%20electronic%20music%20party%20with%20neon%20stage%20lights%20and%20dancing%20crowd%20at%20night%2C%20vibrant%20warm%20orange%20glow%20on%20dark%20blue%20backdrop%2C%20cinematic%20wide%20shot%2C%20high%20detail&width=1280&height=720&seq=vs-v15&orientation=landscape',
    categoryId: 'music',
    subCategory: '派对现场',
    tags: ['电音', '派对', '现场'],
    duration: 445,
    uploadDate: '2026-09-28',
    views: 268900,
    uploader: '音浪研究所',
    featured: false,
  },
  {
    id: 'v16',
    title: '城市马拉松万人开跑：每一步都算数',
    description:
      '从清晨的发令枪到终点线的拥抱，记录一场城市马拉松的完整影像。汗水、坚持与欢呼，属于每一位跑者。',
    cover:
      'https://readdy.ai/api/search-image?query=City%20marathon%20runners%20crowd%20on%20an%20urban%20street%20at%20sunrise%20with%20warm%20golden%20light%2C%20energetic%20dynamic%20atmosphere%2C%20deep%20navy%20shadows%2C%20sports%20editorial%20photography%2C%20high%20detail&width=1280&height=720&seq=vs-v16&orientation=landscape',
    categoryId: 'sports',
    subCategory: '跑步赛事',
    tags: ['马拉松', '跑步', '城市'],
    duration: 701,
    uploadDate: '2026-10-08',
    views: 405600,
    uploader: '跑者视界',
    featured: false,
  },
  {
    id: 'v17',
    title: '街头篮球高光集锦：把对手晃到怀疑人生',
    description:
      '精选街头篮球最炸裂的高光时刻，变向、后撤步与绝杀一网打尽，篮球迷不容错过的视觉盛宴。',
    cover:
      'https://readdy.ai/api/search-image?query=Street%20basketball%20game%20on%20an%20outdoor%20court%20at%20dusk%20with%20dramatic%20warm%20lighting%2C%20dynamic%20action%20pose%20and%20urban%20background%2C%20deep%20navy%20shadows%2C%20sports%20editorial%20photography%2C%20high%20detail&width=1280&height=720&seq=vs-v17&orientation=landscape',
    categoryId: 'sports',
    subCategory: '篮球',
    tags: ['篮球', '街头', '集锦'],
    duration: 389,
    uploadDate: '2026-10-05',
    views: 559300,
    uploader: '街球汇',
    featured: false,
  },
  {
    id: 'v18',
    title: '滑板少年极限挑战：失败一百次也要成一次',
    description:
      '跟拍一位滑板少年挑战高难度动作的全过程，反复摔倒又爬起，献给每一个不肯认输的年轻人。',
    cover:
      'https://readdy.ai/api/search-image?query=Skateboarder%20performing%20a%20trick%20at%20an%20urban%20plaza%20during%20golden%20hour%2C%20dynamic%20motion%20and%20warm%20sunlight%2C%20deep%20navy%20shadows%2C%20action%20sports%20editorial%20photography%2C%20high%20detail&width=1280&height=720&seq=vs-v18&orientation=landscape',
    categoryId: 'sports',
    subCategory: '极限运动',
    tags: ['滑板', '极限', '少年'],
    duration: 466,
    uploadDate: '2026-09-29',
    views: 231400,
    uploader: '街头挑战者',
    featured: false,
  },
  {
    id: 'v19',
    title: '新版本BOSS无伤通关：保姆级打法教学',
    description:
      '新版本最难 BOSS 的无伤通关实录，逐阶段拆解机制与走位技巧，即使是新手也能照着打。',
    cover:
      'https://readdy.ai/api/search-image?query=Epic%20video%20game%20boss%20fight%20scene%20with%20dramatic%20warm%20lighting%20and%20glowing%20effects%2C%20cinematic%20fantasy%20atmosphere%20with%20deep%20blue%20shadows%2C%20stylized%20digital%20art%2C%20high%20detail&width=1280&height=720&seq=vs-v19&orientation=landscape',
    categoryId: 'gaming',
    subCategory: '攻略教学',
    tags: ['攻略', 'BOSS', '无伤'],
    duration: 1152,
    uploadDate: '2026-10-11',
    views: 688900,
    uploader: '无伤教父',
    featured: false,
  },
  {
    id: 'v20',
    title: '电竞比赛逆天翻盘：最后三分钟绝地反击',
    description:
      '电竞赛场上的经典翻盘名局复盘，从经济落后到逆转取胜，带你逐帧感受那决定胜负的最后三分钟。',
    cover:
      'https://readdy.ai/api/search-image?query=Esports%20tournament%20arena%20with%20large%20screens%20and%20glowing%20stage%20lights%2C%20excited%20crowd%20and%20dramatic%20warm%20atmosphere%2C%20deep%20blue%20dark%20interior%2C%20editorial%20photography%2C%20high%20detail&width=1280&height=720&seq=vs-v20&orientation=landscape',
    categoryId: 'gaming',
    subCategory: '电竞赛事',
    tags: ['电竞', '翻盘', '比赛'],
    duration: 934,
    uploadDate: '2026-10-06',
    views: 812700,
    uploader: '赛场复盘室',
    featured: false,
  },
  {
    id: 'v21',
    title: '我的世界建筑大神作品：一座城市在方块里诞生',
    description:
      '走进建筑大神在方块世界里建造的整座城市，从街道到夜景，每一个方块都藏着惊人的耐心与想象。',
    cover:
      'https://readdy.ai/api/search-image?query=Voxel%20block%20city%20landscape%20built%20in%20a%20pixel%20sandbox%20game%20at%20dusk%20with%20warm%20glowing%20windows%2C%20surreal%20creative%20atmosphere%2C%20deep%20blue%20sky%2C%20digital%20render%2C%20high%20detail&width=1280&height=720&seq=vs-v21&orientation=landscape',
    categoryId: 'gaming',
    subCategory: '游戏创作',
    tags: ['建筑', '沙盒', '创作'],
    duration: 742,
    uploadDate: '2026-10-02',
    views: 356800,
    uploader: '方块建筑师',
    featured: false,
  },
  {
    id: 'v22',
    title: '深夜食堂探店：藏在巷子里的烟火气',
    description:
      '深夜走进一条不起眼的小巷，寻找那些只在夜晚营业的小馆子，一口热汤下肚，治愈整天的疲惫。',
    cover:
      'https://readdy.ai/api/search-image?query=Cozy%20late%20night%20food%20stall%20in%20a%20narrow%20alley%20with%20warm%20hanging%20lights%20and%20steaming%20dishes%2C%20inviting%20warm%20atmosphere%2C%20deep%20blue%20night%20shadows%2C%20food%20editorial%20photography%2C%20high%20detail&width=1280&height=720&seq=vs-v22&orientation=landscape',
    categoryId: 'life',
    subCategory: '美食探店',
    tags: ['探店', '深夜', '美食'],
    duration: 528,
    uploadDate: '2026-10-07',
    views: 594100,
    uploader: '深夜寻味',
    featured: false,
  },
  {
    id: 'v23',
    title: '海岛度假旅行记录：把日子过成慢镜头',
    description:
      '一次说走就走的海岛旅行记录，白沙滩、椰林与日落，把节奏放慢，认真感受每一段被海风吹过的时光。',
    cover:
      'https://readdy.ai/api/search-image?query=Tropical%20island%20beach%20at%20sunset%20with%20soft%20waves%20and%20palm%20trees%2C%20warm%20golden%20light%20reflecting%20on%20the%20water%2C%20calm%20serene%20atmosphere%20with%20deep%20blue%20tones%2C%20travel%20editorial%20photography%2C%20high%20detail&width=1280&height=720&seq=vs-v23&orientation=landscape',
    categoryId: 'life',
    subCategory: '旅行记录',
    tags: ['海岛', '度假', '旅行'],
    duration: 611,
    uploadDate: '2026-09-26',
    views: 277300,
    uploader: '背包去远方',
    featured: false,
  },
  {
    id: 'v24',
    title: '萌宠日常治愈合集：被需要的感觉真好',
    description:
      '收集各种毛孩子最治愈的日常瞬间，等门、撒娇与依偎，愿这些温柔的片段能替你赶走所有坏情绪。',
    cover:
      'https://readdy.ai/api/search-image?query=Adorable%20cute%20pets%20relaxing%20in%20a%20warm%20cozy%20home%20with%20soft%20afternoon%20light%2C%20gentle%20comforting%20atmosphere%2C%20warm%20beige%20tones%20with%20deep%20blue%20shadows%2C%20pet%20editorial%20photography%2C%20high%20detail&width=1280&height=720&seq=vs-v24&orientation=landscape',
    categoryId: 'funny',
    subCategory: '萌宠搞笑',
    tags: ['萌宠', '治愈', '日常'],
    duration: 402,
    uploadDate: '2026-10-04',
    views: 1035000,
    uploader: '毛孩子日常',
    featured: false,
  },
];